// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-6-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.12587 13C7.88442 13.5337 7.75 14.1261 7.75 14.75C7.75 17.0972 9.65279 19 12 19C14.3472 19 16.25 17.0972 16.25 14.75C16.25 12.4028 14.3472 10.5 12 10.5C10.2766 10.5 8.79286 11.5257 8.12587 13ZM8.12587 13L13 4.5H13.003L8.12587 13Z","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers61Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-6-1',
    ref,
    icon: element,
  },
));

Numbers61Icon.displayName = 'Numbers61Icon';

export default Numbers61Icon;
